import { useState } from 'react';
import { useRouter } from 'next/router';
import Link from 'next/link';

import UseModal from 'hooks/use-modal';

import { useQuery } from 'react-query';
import { userProfileService } from 'services/auth';
import { isUserLoggedIn, getAccessToken } from 'utils/authentication';
import { MOBILE_FULLSCREEN, NORMAL } from '@core/constants/ModalTypes';

import Avatar from 'components/pages/profile/Avatar';
import FullNameForm from 'components/pages/profile/FullNameForm';
import JobForm from 'components/pages/settings/jobform/JobForm';
import Modal from '@core/components/Modal/Modal';

// import icons
import SmsIcon from 'assets/icons/sms-icon.svg';
import CheckIcon from 'assets/icons/check-icon.svg';
import { Edit } from 'iconsax-react';
import ProfileSetting from 'components/pages/settings/ProfileSetting';

import classes from './UserInfo.module.scss';


const UserInfo = ({ data, refetch, type = '', toast, certificateMetaData, refetchCertificateMetaData }) => {
    const { showModal, destroyModal, show } = UseModal();
    return (
        <>
            <div className={`${classes['user-box']}`}>
                <div className={classes['user-image-wrapper']}>
                    <Avatar imageURL={data.data.image} refetchHandler={refetch} size='small' />
                </div>
                <div className={`${classes['info']}`}>
                    {data.data.is_name_verified ? (
                        <div
                            className={`${classes['fill-name']}`}>{`${data.data.first_name} ${data.data.last_name}`}</div>
                    ) : (
                        <div
                            className={`${classes['empty-name']}`}
                            role="button"
                            tabIndex={0}
                            onClick={() => showModal()}>
                            Add your name
                        </div>
                    )}
                    <div className={`${classes['user-email']}`}>
                        {data.data.email}
                        {data.data.is_verified && <CheckIcon />}
                    </div>

                </div>
                {
                    !data.data.is_verified && (
                        <div className={`${classes['email-not-verified']}`}>
                            <div className={`${classes['msg-container']}`}>
                                <SmsIcon />
                                <div className={`${classes['text']}`}>Email not verified yet</div>
                            </div>
                            <div className={`${classes['action-container']}`}>
                                <Link href="/verification">Verify now</Link>
                                <div className={`${classes['icon']}`}></div>
                            </div>
                        </div>
                    )
                }
                {certificateMetaData && (
                    <ProfileSetting data={certificateMetaData.data} refetchCertificateMetaData={refetchCertificateMetaData} toast={toast} />
                )}
            </div>
           
            <Modal show={show} closeHandler={destroyModal} type={MOBILE_FULLSCREEN}>
                <FullNameForm closeModal={destroyModal} refetchHandler={refetch} />
            </Modal>
        </>
    );
};

export default UserInfo;